import httpService from "./httpService";
import utils from "./utils";

export default {
  findAll: function(example, pageable) {
    var params = utils.merge(example, pageable);

    return httpService.get("globalConfig", { params: params });
  },
  findById(id) {
    return httpService.get("globalConfig/" + id);
  },
  findByCode(code) {
    return httpService.get(`globalConfig/findByCode/${code}`);
  },
  update(id) {
    return httpService.put(`/globalConfig/updateStatus/${id}`)
  }
};



// WEBPACK FOOTER //
// ./src/services/globalConfigService.js